module.exports = __webpack_public_path__ + "static/img/mark_Img.6e2d3679.png";